export default __webpack_public_path__ + "static/media/2023_März_Danke.21117ed2.webp";